import { createContext, useContext, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const HouseholdContext = createContext(null);
const KEY = "cashmy.household";

export function HouseholdProvider({ children }) {
  const { user } = useAuth();
  const [activeId, setActiveId] = useState(() => localStorage.getItem(KEY));
  const households = user?.households || [];
  const active = households.find((h) => h.id === activeId) || households[0] || null;

  const select = (id) => {
    localStorage.setItem(KEY, id);
    setActiveId(id);
  };

  return <HouseholdContext.Provider value={{ households, active, select }}>{children}</HouseholdContext.Provider>;
}

export const useHousehold = () => useContext(HouseholdContext);
